export default "__VITE_ASSET__5e7d401b__"